import { ErrorPage } from "./ErrorPage";

export const FourOhFour = () => {
  return <ErrorPage title={"Page not found"} />;
};
